// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"130":"23d46c36","313":"46221a15","407":"f7a4ea0a","532":"b02dbdcc","753":"e73cff8e","804":"c7336438","988":"7d24ef32"}[chunkId] + ".chunk.js";
};